/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsVideoSlider = {
    init: function ($section) {
      
      // Iframe Video
      $('.iframe_video_enable').on('click', function(ev) {
        $(this).hide();
        $(this).closest('.video-wrap').find("iframe#ivideo").attr("src", function(i, val) {
          return val + "&autoplay=1";
        });
        ev.preventDefault();
      });

      // HTML Video
      $('.html_video_enable').on('click', function() {
        $(this).hide();
        $(this).next(".video").attr("controls", "controls");
        var video = $(this).siblings('.video')[0];
        video.play();
      });

      $('.video-slider-section .container').flickity({
        lazyLoad: 2,
        imagesLoaded: true,  
        draggable: true,  
        cellAlign: 'left',
        wrapAround: true,
        pageDots: true,
        contain: true,
        prevNextButtons: true,
        initialIndex: 0,        
        arrowShape: arrowShape
      });
    },    
    unload: function ($section) {}
  }
})();
